import { defineComponent } from "@openuidev/lang-core";
import { z } from "zod";

// Science widgets. See ../widgets.ts for the rules all widgets follow.

const label = (max: number) => z.string().trim().min(1).max(max);

export const FairTest = defineComponent({
  name: "FairTest",
  description:
    'Plan a fair test: for each of 2 to 6 variables the child picks "I change", "I measure" or "I keep the same", then shares the plan. Use when designing an experiment. Never say which choice is right.',
  props: z.object({
    variables: z.array(label(40)).min(2).max(6),
    question: label(200).optional(),
  }),
  component: null,
});

export const CycleDiagram = defineComponent({
  name: "CycleDiagram",
  description:
    "3 to 8 stages drawn around a circle, in order, each with an optional short description the child can open. Use to show a cycle (water cycle, life cycle of a butterfly, seasons).",
  props: z.object({
    title: label(60),
    stages: z
      .array(
        z.object({
          label: label(24),
          description: label(160).optional(),
        }),
      )
      .min(3)
      .max(8),
  }),
  component: null,
});

export const DataChart = defineComponent({
  name: "DataChart",
  description:
    "A small bar chart of experiment or survey data you give (content numbers, never the child's progress). Use to read and compare results. Values are 0 or more; yMax optionally fixes the top of the axis.",
  props: z.object({
    title: label(80),
    unit: z.string().trim().max(16),
    bars: z
      .array(
        z.object({
          label: label(24),
          value: z.number().min(0).max(1_000_000),
        }),
      )
      .min(2)
      .max(8),
    yMax: z.number().positive().max(1_000_000).optional(),
  }),
  component: null,
});

export const scienceWidgets = [FairTest, CycleDiagram, DataChart] as const;
